<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.0188 21C7.2123 20.9959 3.25214 17.2274 3.0115 12.4287C2.77086 7.63008 6.33417 3.48461 11.1161 3V6.6453C8.39974 7.10418 6.46204 9.53014 6.6157 12.2797C6.76936 15.0293 8.9653 17.2244 11.7159 17.378C14.4665 17.5316 16.8934 15.5947 17.3524 12.8793H20.9991C20.5295 17.4869 16.6511 20.9938 12.0179 21H12.0188ZM21 11.0747H17.3533C16.9692 8.80603 15.191 7.02883 12.9214 6.6453V3C17.1882 3.4367 20.5618 6.80859 20.9991 11.0738L21 11.0747Z"
            fill="currentColor" />
    </svg>
</template>

<script>
export default {
    name: 'DashboardIcon'
}
</script>